
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Livello 1","viewBox":"0 0 128 128","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.09 32.91a3 3 0 002.12-.91L61 10.24V91a3 3 0 006 0V10.24L88.79 32A3 3 0 0093 27.79L66.12.88a3 3 0 00-.46-.38l-.23-.12a3 3 0 00-.29-.15 3 3 0 00-.31-.1l-.24-.07a3 3 0 00-1.18 0l-.25.08a2.93 2.93 0 00-.31.1 3 3 0 00-.29.15l-.22.11a3 3 0 00-.46.38L35 27.79a3 3 0 002.12 5.12z"}}),_c('path',{attrs:{"d":"M125 88a3 3 0 00-3 3v22a9 9 0 01-9 9H15a9 9 0 01-9-9V91a3 3 0 00-6 0v22a15 15 0 0015 15h98a15 15 0 0015-15V91a3 3 0 00-3-3z"}})])
          )
        }
      }
    